import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import EarQCharts from './EarQCharts'
import {toLocalDate} from '../../../utils/Utils'


function EarQChartsModal(props) {

    const handleClose = () => {
        props.onClose()
    }

    return (
        <Modal size="fullscreen" show={props.show} onHide={handleClose} animation={false} scrollable={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3>The Ear-Q</h3>
                </Modal.Title>
            </Modal.Header>
        <Modal.Body>
            <EarQCharts
                // dictVisit={props.dictVisit}
                // dictPanelId={props.dictPanelId}
                viewType='full'
                loaded={new Date()}
            />
        </Modal.Body>

        <Modal.Footer className='justify-content-between'>

            
            <div >
                <Button className='mx-2' variant="secondary" onClick={handleClose}>
                    Close
                </Button>

            </div>
            
        </Modal.Footer>
    </Modal>







    )
}

export default EarQChartsModal
